export default __webpack_public_path__ + "static/media/crab.db7b303c.svg";